import MemberSignature from './MemberSignature';

export default MemberSignature;
